import getUtag from "./getUtag";
import { trackViewSequentially, trackEventSequentially, } from "./sequenceDecorator";
export var trackView = function (viewDataGetters) {
    if (typeof window === "undefined") {
        console.warn("@argonaut/analytics function calls should be wrapped in a useEffect hook to prevent them running on the server");
    }
    else {
        void trackViewSequentially(getUtag, viewDataGetters);
    }
};
export var trackEvent = function (eventDataGetter) {
    void trackEventSequentially(getUtag, eventDataGetter);
};
//# sourceMappingURL=browserDecorator.js.map